module.exports = __webpack_public_path__ + "img/bodyWoman.aa0e587f.png";